export const clearTranslationDrafts = () => {
  Object.keys(localStorage)
    .filter((key) => key.startsWith('translationDraft_'))
    .forEach((key) => localStorage.removeItem(key));
};

export default clearTranslationDrafts;
